import { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { setStoredToken, clearStoredToken } from '../lib/authToken';

const API = process.env.REACT_APP_BACKEND_URL;
const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = not auth'd, object = auth'd
  const [loading, setLoading] = useState(true);

  useEffect(() => { checkAuth(); }, []);

  const checkAuth = async () => {
    try {
      const res = await axios.get(`${API}/api/auth/me`, { withCredentials: true });
      setUser(res.data);
    } catch {
      setUser(false);
    }
    setLoading(false);
  };

  const login = async (email, password) => {
    const res = await axios.post(`${API}/api/auth/login`, { email, password }, { withCredentials: true });
    // Iter 132 — persist the bearer token returned by the backend so Safari
    // / iCloud Private Relay sessions survive the cookie being stripped.
    if (res.data?.access_token) {
      setStoredToken(res.data.access_token);
    }
    setUser(res.data);
    return res.data;
  };

  const logout = async () => {
    try {
      await axios.post(`${API}/api/auth/logout`, {}, { withCredentials: true });
    } finally {
      // Always clear local state even if the network call fails — otherwise
      // a stale token in localStorage keeps the user "logged in" client-side.
      clearStoredToken();
      setUser(false);
    }
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, checkAuth, refresh: checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
